/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import {
  FunctionOutlined,
  LinkOutlined,
  PushpinOutlined,
} from '@ant-design/icons';
import { Dropdown } from '@framework/ui';
import { Button } from 'antd';
import { SizeType } from 'antd/es/config-provider/SizeContext';
import { MenuProps } from 'antd/es/menu';
import * as React from 'react';
import { ExpressionType } from '../../../IExpression';
import { AssignableExpressionType } from '../IAssignableExpression';

export interface IAssignableExpressionTypeSelectorProps {
  /** Valore selezionato */
  value: AssignableExpressionType | undefined;
  /** Tipi validi */
  allowedTypes?: AssignableExpressionType[];
  /** Viene notificato quando l'utente seleziona un tipo differente */
  onChange: (type: AssignableExpressionType) => void;

  size?: SizeType;

  disabled?: boolean;
}

/**
 * Selettore del tipo di espressione (valore, riferimento, funzione)
 *
 * Per i colori vedi https://maketintsandshades.com/#e91e63,4caf50,2196f3 90%
 */
export function AssignableExpressionTypeSelector(
  props: IAssignableExpressionTypeSelectorProps,
) {
  // Allineare con `AllAssignableExpressionTypes`
  let items = [
    {
      key: ExpressionType.Value,
      label: 'Valore',
      icon: <PushpinOutlined />,
      style: { backgroundColor: '#e9f5fe', color: '#2196f3', margin: '4px' }, // #2196f3
    },
    {
      key: ExpressionType.Reference,
      label: 'Riferimento',
      icon: <LinkOutlined />,
      style: { backgroundColor: '#edf7ee', color: '#4caf50', margin: '4px' }, // #4557b7
    },
    {
      key: ExpressionType.Function,
      label: 'Funzione',
      icon: <FunctionOutlined />,
      style: { backgroundColor: '#fde9ef', color: '#e91e63', margin: '4px' },
    },
    // {
    //   key: ExpressionType.Async,
    //   label: 'Servizio Web',
    //   icon: <ApiOutlined />,
    //   style: { backgroundColor: '#f1eafa', color: '#8043d6', margin: '4px' }
    // }
  ] satisfies MenuProps['items'];

  if (props.allowedTypes) {
    items = items.filter(item =>
      props.allowedTypes?.includes(item.key as AssignableExpressionType),
    );
  }

  const selected = items.find(item => item.key === props.value) ?? items[0];

  return (
    <Dropdown
      menu={{
        selectable: true,
        selectedKeys: [],
        items,
        onClick: info => {
          props.onChange(info.key as AssignableExpressionType);
        },
      }}
      disabled={props.disabled}
    >
      <Button
        size={props.size || 'middle'}
        type="default"
        icon={selected.icon}
        style={{ color: selected.style.color }}
        disabled={props.disabled}
      />
    </Dropdown>
  );
}
